<template>
  <v-app id="vjago">
    <!-- Show app or loading screen -->
    <the-loader v-if="$store.state.loading" />

    <router-view v-else />

    <the-alert-snackbar />
  </v-app>
</template>

<script>
import TheAlertSnackbar from '@/components/TheAlertSnackbar'
import TheLoader from '@/components/TheLoader'

export default {
  components: {
    TheAlertSnackbar,
    TheLoader
  },
  computed: {
    appBarProps () {
      const src = this.$store.state.navigation.image

      let props = {
        'shrink-on-scroll': !!src,
        prominent: !!src,
        flat: !src,
        absolute: !src
      }

      if (src) {
        props.src = src
      }

      return props
    },
    backRoute () {
      if (this.$route.meta && this.$route.meta.parent) {
        return { name: this.$route.meta.parent, params: this.$route.params }
      }
      return null
    }
  },
  mounted () {
    this.$store.dispatch('doFirstLoad')

    window.addEventListener('beforeinstallprompt', (e) => {})
  }
}
</script>

<style lang="scss">
html {
  overflow: auto;
}

#vjago {
  &.theme--light.v-application {
    background: #f2f3f6;
  }

  // &.theme--dark.v-application {
  //   background: #1d1f27;
  // }
}
</style>
